<template>
    <div class="rate-visualizer">
        <template v-if="item.id != null">
            <div style="width: 120px;">
                {{$formats.formatAmount(accountBalances(item)[0].endBalance / 100)}}
            </div>
             [{{$formats.formatDate(new Date(accountBalances(item)[0].balanceDate))}}]

<!--            <trend-->
<!--                    :data="accountBalances(item)"-->
<!--                    :gradient="['white']"-->
<!--                    stroke-width="2px"-->
<!--                    :width="100"-->
<!--                    :height="24"-->
<!--            />-->
        </template>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "AccountVisualizer",
        props: {
            item: Object
        },
        computed: {
            ... mapGetters({
                "accountBalances": "banking/accountBalances"
            })
        },
        data: function () {
            return {}
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/global";
    .rate-visualizer {
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: start;
    }
</style>